import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { LoginButtonInterface } from 'src/shared/types/entities/login-button-interface'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'

export const createLoginButton = (
  parentId: string,
  text: string,
  subText: string,
  masterBlockId?: MasterBlockId,
): LoginButtonInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.LoginButton, parentId, masterBlockId),
    buttonType: WebsiteSettingsTypographyTypeEnum.SecondaryButton,
    iconClassNameBefore: '',
    iconClassNameAfter: '',
    alignSelf: 'center',
    text,
    subText,
    width: 'auto',
    boxShadow: 'none',
    mobileWidth: '100%',
    mobileAlignSelf: 'center',
    mobileBoxShadow: 'none',
  }
}
